import React, { useEffect, useContext, useState, useRef } from 'react'
import moment from 'moment'
import 'moment/locale/fr'
import {
  Hidden,
  Box,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';


import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CancelIcon from '@material-ui/icons/Cancel';
import CloseIcon from '@material-ui/icons/Close';
import {
  UploadCloud as UploadCloudIcon,
} from 'react-feather';

import ScansContext from "../../contexts/ScansContext"

import { readString } from "react-papaparse"
import APIS from "../../utils/APIS"

moment.locale("fr");


const AddMultipleCandidats = ({actScan, onClose}) => {

  const theme = useTheme();
  const mediaQueryUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  const { getScans } = useContext(ScansContext)

  const [step, setStep] = useState(0)
  const handleChange = (event) => {
    setFileStatus({
      ...fileStatus,
      selectColumn: event.target.value,
    })
  }

  const [candidatsFile, setCandidatsFile] = useState(null)
  const [fileStatus, setFileStatus] = useState({})
  const uploadInputRef = useRef(null)
  const onChangeUploadInput = (e) => {
    if (e?.target?.files[0]) {
      setCandidatsFile(e?.target?.files[0])
      setFileStatus({})
    }

    var reader = new FileReader();
    reader.onload = function(e) {
      if (reader.result) {
        readString(reader?.result, {
          skipEmptyLines: "greedy",
          header:true,
          delimiter:",",
          complete: (results) => {
            if (results.errors && results.errors.length > 0) {
              setFileStatus({status:"error"})
            } else if (results.data && results.data.length > 0 & results?.meta?.fields?.length > 0) { //OK
              let datas = results.data
              let headers = results?.meta?.fields
              if (datas?.length >= 1 && datas?.length <= 100) {
                //on regarde chaque colonne voir si c'est vide
                let finalHeaders = []
                headers.forEach((header) => {
                  let thisCount = 0
                  datas?.forEach((data) => {
                    if (data[header]) {
                      thisCount++
                    }
                  })
                  finalHeaders.push({
                    header : header,
                    count : thisCount
                  })
                })
                finalHeaders = finalHeaders.filter((el) => el.count > 0)
                finalHeaders = finalHeaders.map((el) => el.header)
                if (finalHeaders?.length > 0) {
                  setFileStatus({
                    status : "ok",
                    finalHeaders : finalHeaders,
                    datas : datas,
                    selectColumn : finalHeaders[0],
                  })
                } else {
                  setFileStatus({status:"error"})
                }
              } else {
                setFileStatus({status:"error"})
              }
            } else {
              setFileStatus({status:"error"})
            }
          },
        })
      } else {
        setFileStatus({status:"error"})
      }
    }
    try {
      reader.readAsText(e?.target?.files[0]);
    } catch (e) {
      console.log(e)
    }
  }


  return (
    <>
      <Hidden smUp>
        <Box sx={{
          paddingLeft:"5px",
          paddingRight:"5px",
          paddingTop:"10px",
          display:"flex",
          overflow:"hidden",
          maxWidth:"100%",
          gap:"5px",
        }}>
          <Button
            variant="text"
            size={"medium"}
            onClick={() => { }}
            sx={{
              padding:"0px 4px",
              minWidth:0,
              visibility:"hidden",
            }}
          >
            <ChevronLeftIcon/>
          </Button>
          <Box sx={{
            flexGrow:1,
            fontSize:"16px",
            color:"text.primary",
            fontWeight:400,
            textAlign:"center",
            textOverflow:"ellipsis",
            overflow:"hidden",
            whiteSpace:"nowrap",
            useSelect:"none",
            textTransform:"capitalize",
          }}>
            {actScan?.name}
          </Box>
          <Button
            variant="text"
            size={"medium"}
            onClick={onClose}
            sx={{
              padding:"0px 4px",
              minWidth:0,
            }}
          >
            <CloseIcon/>
          </Button>
        </Box>
      </Hidden>
      <Box sx={{
        display:"flex",
        flexDirection:"column",
        height:"100%",
        padding:["25px", "30px", "40px"],
        gap:"20px",
      }}>
        <Box sx={{
          textAlign:"center",
          color:"text.black",
          fontWeight:500,
          fontSize:["22px", "36px", "36px"],
        }}>
          Liste de candidats
        </Box>
        <input ref={uploadInputRef} name="fileCandidats" type="file" accept="text/csv" style={{display:"none"}} onChange={onChangeUploadInput}/>

        {(step === 2  || step === 3) &&
          <>
            <Box sx={{
              textAlign:"center",
              color:"text.primary",
              fontWeight:400,
              fontSize:["15px", "18px", "18px"],
            }}>
              Vérification et envoi des invitations ...
            </Box>
            <Box sx={{flexGrow:1, display:"flex", justifyContent:"center"}}>
              {step === 2 &&
                <CircularProgress size="60px" sx={{
                  marginTop:"8px",
                  marginBottom:"8px",
                }}/>
              }
              {step === 3 &&
                <>
                  {fileStatus?.finalError ? (
                    <Box sx={{
                      fontSize:"22px",
                      fontWeight : 500,
                      color:"red",
                      textAlign:"center",
                    }}>
                      Une erreur est survenue, merci de vérifier vos données.
                    </Box>
                  ) : (
                    <Box sx={{
                      marginTop:"8px",
                      marginBottom:"8px",
                    }}>
                      {(fileStatus?.finalResult?.complete?.length === 0 && fileStatus?.finalResult?.errors?.length > 0) &&
                        <Box sx={{
                          fontSize:"20px",
                          fontWeight : 500,
                          color:"text.black",
                          textAlign:"center",
                        }}>
                          Malheureusement votre liste ne comporte que des emails inutilisables, merci de vérifier vos données.
                        </Box>
                      }
                      {(fileStatus?.finalResult?.complete?.length > 0 && fileStatus?.finalResult?.errors?.length === 0) &&
                        <Box sx={{
                          fontSize:"20px",
                          fontWeight : 500,
                          color:"text.black",
                          textAlign:"center",
                        }}>
                          Nous avons invités {fileStatus?.finalResult?.complete?.length} candidats !
                        </Box>
                      }
                      {(fileStatus?.finalResult?.complete?.length > 0 && fileStatus?.finalResult?.errors?.length > 0) &&
                        <Box sx={{
                          fontSize:"20px",
                          fontWeight : 500,
                          color:"text.black",
                          textAlign:"center",
                        }}>
                          Nous avons invités {fileStatus?.finalResult?.complete?.length} candidats !
                          <br/><br/>
                          Malheureusement, {fileStatus?.finalResult?.errors?.length} emails sont en échec, merci de vérifier vos données.
                        </Box>
                      }
                    </Box>
                  )}
                </>
              }
            </Box>
            <Box sx={{display:"flex", flexDirection:"column", gap:"5px", alignItems:"center"}}>
              <Button
                color="primary"
                size="large"
                fullWidth
                sx={{
                  maxWidth:"420px",
                }}
                variant="contained"
                onClick={onClose}
                disabled={step === 3 ? false : true}
              >
                Fermer
              </Button>
            </Box>
          </>
        }

        {step === 1 &&
          <>
            <Box sx={{
              textAlign:"center",
              color:"text.primary",
              fontWeight:400,
              fontSize:["15px", "18px", "18px"],
            }}>
              Sélectionner la colonne contenant les emails.
            </Box>
            <Box sx={{flexGrow:1, display:"flex", justifyContent:"center"}}>
              {fileStatus?.status === "ok" ? (
                  <FormControl
                    fullWidth
                    sx={{
                      marginTop:"16px",
                      marginBottom:"8px",
                      maxWidth:"420px",
                      "& .MuiInputBase-root": {
                        background:mediaQueryUpSm ? "#FAF8F6" : "white",
                      },
                      "& .MuiInputBase-input" : {
                        flexDirection:"column",
                        display:"flex",
                      },
                    }}
                  >
                    <InputLabel id="selectEmailColumn-label">Adresse Email</InputLabel>
                    <Select
                      label="Adresse Email"
                      labelId="selectEmailColumn-label"
                      id="selectEmailColumn"
                      value={fileStatus?.selectColumn}
                      onChange={handleChange}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            maxWidth:"420px",
                            '& .MuiMenuItem-root': {
                              flexDirection: "column",
                              alignItems:"flex-start",
                            },
                          },
                        },
                      }}
                    >
                      {fileStatus?.finalHeaders?.map((header, index) => {
                        let lists = []
                        fileStatus?.datas?.forEach((data) => {
                          let val = data[header]
                          if (val) {
                            lists.push(data[header])
                          }
                        })
                        let stringList = lists.join(', ')
                        return (
                          <MenuItem key={index} value={header}>
                            <span style={{fontWeight:400, fontSize:"16px", color:"black", textTransform:"capitalize"}}>
                              {header}
                            </span>
                            <span style={{fontWeight:400, fontSize:"13px", color:"#565656", overflow:"hidden", whiteSpace:"nowrap", textOverflow:"ellipsis", maxWidth:"100%"}}>
                              {stringList}
                            </span>
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
              ) : (
                <Box sx={{
                  fontSize:"22px",
                  fontWeight : 500,
                  color:"red",
                  textAlign:"center",
                }}>
                  Une erreur est survenue, merci de vérifier vos données.
                </Box>
              )}
            </Box>
            <Box sx={{display:"flex", flexDirection:"column", gap:"5px", alignItems:"center"}}>
              <Button
                color="primary"
                size="large"
                fullWidth
                sx={{
                  maxWidth:"420px",
                }}
                variant="contained"
                endIcon={<ChevronRightIcon/>}
                onClick={() => {
                  setStep(2)
                  //on envoie au back pour vérifier les données, inviter et nous retourner les infos et erreurs
                  let emails = []
                  fileStatus?.datas?.forEach((data) => {
                    if (data[fileStatus?.selectColumn]) {
                      emails.push(data[fileStatus?.selectColumn]?.trim())
                    }
                  })
                  let uniqueEmails = [...new Set(emails)]
                  if (uniqueEmails?.length > 0) {
                    let closeDate = moment(actScan?.plan?.plan[0]?.closeDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
                    APIS.addMultipleCandidats({emails : uniqueEmails, groupeID : actScan?.id, closeDate : closeDate}).then((result) => {
                      if (result && result?.message === "addMultipleCandidats") {
                        setFileStatus({
                          ...fileStatus,
                          finalResult : {
                            complete : result?.complete,
                            errors : result?.errors,
                          }
                        })
                        setStep(3)
                        getScans()
                      } else { //error
                        setFileStatus({
                          ...fileStatus,
                          finalError : "error"
                        })
                        setStep(3)
                      }
                    });
                  } else {
                    setFileStatus({
                      ...fileStatus,
                      finalError : "noEmails"
                    })
                    setStep(3)
                  }
                }}
                disabled={(fileStatus?.status === "ok" && fileStatus?.selectColumn) ? false : true}
              >
                Envoyer les invitations
              </Button>
              <Button
                variant="text"
                size={"medium"}
                fullWidth
                onClick={() => {
                  setStep(0)
                }}
                sx={{
                  fontSize:"16px",
                  fontWeight:500,
                  maxWidth:"420px",
                }}
              >
                Retour
              </Button>
            </Box>
          </>
        }

        {step === 0 &&
          <>
            <Box sx={{
              textAlign:"center",
              color:"text.primary",
              fontWeight:400,
              fontSize:["15px", "18px", "18px"],
            }}>
              Sélectionner un fichier .CSV contenant les emails des candidats à inviter sur une colonne, <b>avec ligne d'entête</b>.
            </Box>
            <Box sx={{flexGrow:1, display:"flex", justifyContent:"center"}}>
              <Box
                sx={{
                  marginTop:"8px",
                  marginBottom:"8px",
                  height:"160px",
                  width:"100%",
                  maxWidth:"800px",
                  background:mediaQueryUpSm ? "#FAF8F6" : "white",
                  border:"1px solid #E7E7E7",
                  cursor:"pointer",
                  display:"flex",
                  flexDirection:"column",
                  justifyContent:"center",
                  alignItems:"center",
                  userSelect:"none",
                  gap:"20px",
                  "&:hover":{
                    border:"1px solid black",
                  }
                }}
                onClick={() => uploadInputRef.current && uploadInputRef.current.click()}
              >
                <Box sx={{color:"text.primary", width:["40px", "40px", "45px"]}}>
                  <UploadCloudIcon style={{width:"100%", height:"100%"}}/>
                </Box>
                {candidatsFile === null ? (
                  <>
                    <Box sx={{
                      fontSize:"21px",
                      fontWeight : 500,
                      color:"text.primary",
                    }}>
                      Télécharger une liste
                    </Box>
                    <Box sx={{
                      fontSize:"14px",
                      fontWeight : 500,
                      color:"text.primary",
                    }}>
                      CSV (100 lignes max)
                    </Box>
                  </>
                ) : (
                  <Box sx={{display:"flex", alignItems:"center", gap:"10px"}}>
                    <Box sx={{
                      fontSize:"22px",
                      fontWeight : 500,
                      color:"text.black",
                    }}>
                      {candidatsFile?.name}
                    </Box>
                    <CancelIcon
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setCandidatsFile(null)
                        setFileStatus({})
                        if (uploadInputRef.current) {
                          uploadInputRef.current.value = null
                        }

                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
            <Box sx={{display:"flex", flexDirection:"column", gap:"5px", alignItems:"center"}}>
              <Button
                color="primary"
                size="large"
                fullWidth
                sx={{
                  maxWidth:"420px",
                }}
                variant="contained"
                endIcon={<ChevronRightIcon/>}
                onClick={() => {
                  setStep(1)
                }}
                disabled={candidatsFile === null}
              >
                Continuer
              </Button>
            </Box>
          </>
        }
      </Box>
    </>
  )
}


export default AddMultipleCandidats
